'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_MealORamaState(onUserChanged, user, serverVersion, sidebarVisible, onToggleSidebar) {
  this.sJ = null;
  this.k1 = null;
  this.rj = null;
  this.sK = false;
  this.uB = null;
  this.sJ = onUserChanged;
  this.k1 = user;
  this.rj = serverVersion;
  this.sK = sidebarVisible;
  this.uB = onToggleSidebar;
}
export { $c_Lmealorama_MealORamaState as $c_Lmealorama_MealORamaState };
$p = $c_Lmealorama_MealORamaState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_MealORamaState;
/** @constructor */
function $h_Lmealorama_MealORamaState() {
}
export { $h_Lmealorama_MealORamaState as $h_Lmealorama_MealORamaState };
$h_Lmealorama_MealORamaState.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 829350626);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.sJ));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.k1));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.rj));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.sK ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.uB));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_MealORamaState)) {
    if ((this.sK === x$0.sK)) {
      var x = this.sJ;
      var x$2 = x$0.sJ;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.k1;
      var x$4 = x$0.k1;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.rj;
      var x$6 = x$0.rj;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.uB;
      var x$8 = x$0.uB;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 5;
});
$p.r = (function() {
  return "MealORamaState";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.sJ;
      break;
    }
    case 1: {
      return this.k1;
      break;
    }
    case 2: {
      return this.rj;
      break;
    }
    case 3: {
      return this.sK;
      break;
    }
    case 4: {
      return this.uB;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_MealORamaState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jH)));
}
export { $isArrayOf_Lmealorama_MealORamaState as $isArrayOf_Lmealorama_MealORamaState };
var $d_Lmealorama_MealORamaState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MealORamaState, "mealorama.MealORamaState", ({
  jH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_MealORamaState as $d_Lmealorama_MealORamaState };
//# sourceMappingURL=mealorama.-Meal-O-Rama-State.js.map
